'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _take = require('lodash/take');

var _take2 = _interopRequireDefault(_take);

var _unionBy = require('lodash/unionBy');

var _unionBy2 = _interopRequireDefault(_unionBy);

var _store = require('store');

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storeEmoji = function storeEmoji(emoji) {
  var storedEmojis = _store2.default.get('recent-emoji');

  if (!(0, _isArray2.default)(storedEmojis)) {
    storedEmojis = [];
  }

  _store2.default.set('recent-emoji', (0, _take2.default)((0, _unionBy2.default)([emoji], storedEmojis, 'shortname'), 42));
};

exports.default = storeEmoji;
module.exports = exports.default;